import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/signup/verify-email-address')({
  component: () => Navigate({ to: '/app' }),
})
